/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CompactCruiseSortBy = {
    DEPDATE: 'DEPDATE',
    PRICEMODEL: 'PRICEMODEL',
    ROUTENAME: 'ROUTENAME'
} as const;
export type CompactCruiseSortBy = typeof CompactCruiseSortBy[keyof typeof CompactCruiseSortBy];


export function instanceOfCompactCruiseSortBy(value: any): boolean {
    for (const key in CompactCruiseSortBy) {
        if (Object.prototype.hasOwnProperty.call(CompactCruiseSortBy, key)) {
            if (CompactCruiseSortBy[key as keyof typeof CompactCruiseSortBy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompactCruiseSortByFromJSON(json: any): CompactCruiseSortBy {
    return CompactCruiseSortByFromJSONTyped(json, false);
}

export function CompactCruiseSortByFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompactCruiseSortBy {
    return json as CompactCruiseSortBy;
}

export function CompactCruiseSortByToJSON(value?: CompactCruiseSortBy | null): any {
    return value as any;
}

export function CompactCruiseSortByToJSONTyped(value: any, ignoreDiscriminator: boolean): CompactCruiseSortBy {
    return value as CompactCruiseSortBy;
}

